var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8844 10.8963L9.06039 2.00049C8.86692 1.80384 8.63675 1.64775 8.38314 1.54124C8.12954 1.43472 7.85752 1.37988 7.58278 1.37988C7.30805 1.37988 7.03603 1.43472 6.78243 1.54124C6.52882 1.64775 6.29865 1.80384 6.10518 2.00049C5.71757 2.39359 5.5 2.92535 5.5 3.47963C5.5 4.03391 5.71757 4.56567 6.10518 4.95877L13.4724 12.3859L6.10518 19.8131C5.71757 20.2062 5.5 20.738 5.5 21.2923C5.5 21.8465 5.71757 22.3783 6.10518 22.7714C6.29964 22.9659 6.53026 23.1197 6.78382 23.2241C7.03738 23.3285 7.30889 23.3814 7.58278 23.3798C7.85668 23.3814 8.12819 23.3285 8.38175 23.2241C8.63531 23.1197 8.86593 22.9659 9.06039 22.7714L17.8844 13.8756C18.0795 13.6805 18.2343 13.4485 18.3399 13.1928C18.4456 12.9371 18.5 12.6629 18.5 12.3859C18.5 12.109 18.4456 11.8347 18.3399 11.5791C18.2343 11.3234 18.0795 11.0914 17.8844 10.8963Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.88116393f0bb9315969fd63b8b9a95e6.svg";
export { ForwardRef as ReactComponent };